import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AolService } from '../../services/aol';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { Subject, forkJoin, from } from 'rxjs';
import {
  takeUntil,
  map,
  debounceTime,
  delay,
  distinctUntilChanged,
  tap,
  concatMap,
} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/modules/core/services';

import { OrganizationService } from 'src/modules/features/contractor/services';
import { DocumentService } from '../../services';
import { AppFilter } from '@app/shared/models';
import { LinkDocumentModal } from '../link-document-type-modal/link-document-type-modal.component';
import { PdfViewerService } from '../../services/pdfViewer';
import { ErrorHandlerService } from '@app/shared/services/error-handling';

interface IEditCompanyDetailModalContext {
  data?: any;
  title: string;
}
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-edit-company-detail-modal',
  templateUrl: './edit-company-detail-modal.component.html',
  styleUrls: ['./edit-company-detail-modal.component.scss'],
})
export class EditCompanyDetailModalComponent implements OnInit {
  pending;
  @ViewChild('input') input: ElementRef;
  @ViewChild('h3') h3: ElementRef;

  toEdit;
  organization;
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  documentForm: FormGroup;
  organizationForm: FormGroup;
  fileError;
  fileName: string;
  organizationId: string;

  uploadFormData: any;
  changeRequestId: any;
  currentForm: any;
  companyType: any[];
  ownershipType: any[];
  companyTypeData: any[];
  ownershipTypeData: any[];
  documentUploaded: any = [];
  filter: AppFilter = new AppFilter();

  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
    ],
  };
  documentFilterCompany = {
    groupOp: 'OR',
    rules: [],
  };
  optionFilterCompany = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
    ],
  };

  optionFilterOwner = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
    ],
  };

  optionFilterForeign = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
    ],
  };
  fileNameArr: any = {};
  allFiles = [];
  companyEmailLoading: boolean;
  companyEmailError: boolean = true;
  companyEmailServerError: boolean;
  countries: any;
  states: any;
  public mode: DatepickerMode = 'date';
  documentss: Document[];
  companyTypes;
  onFileChanges(event: any, document: Document): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const uploadedFiles: File[] = Array.from(fileList);
      document.uploadedFiles = document.uploadedFiles || [];
      document.uploadedFiles = [...document.uploadedFiles, ...uploadedFiles];
    }
    this.uploadedDocuments = this.documentss
      .filter((doc) => doc.uploadedFiles && doc.uploadedFiles.length > 0)
      .map(({ uploadedFiles, ...rest }) => ({ ...rest, uploadedFiles }));
  }
  uploadedDocuments: any = [];
  removeDocument(index: number): void {
    this.documentss.splice(index, 1);
  }

  removeFile(document: Document, fileIndex: number): void {
    if (document.uploadedFiles) {
      document.uploadedFiles.splice(fileIndex, 1);
    }
  }
  removeLinkedDocument(doc, index) {
    if (doc) {
      this.allLinkedDocuments.splice(index, 1);
    }
  }
  editLinkedDocument(doc, index, data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Edit Selected existing documents from ${data} Document Type`,
          doc,
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        if (doc) {
          this.allLinkedDocuments[index] = documents[0];
        }
      })
      .onDeny(() => {});
  }
  editFile(event: any, document: Document, fileIndex: number): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const newFile: File = fileList[0];

      // Replace the existing file at the specified index
      if (document.uploadedFiles && document.uploadedFiles[fileIndex]) {
        document.uploadedFiles[fileIndex] = newFile;
      }
    }
  }

  onSubmit(): void {
    // Collect the uploaded documents for submission
    const uploadedDocuments = this.documentss.filter(
      (doc) => doc.uploadedFiles
    );

    // Send the uploadedDocuments array to your backend for further processing
    console.log('Uploaded Documents:', uploadedDocuments);
  }
  confirmedTin: boolean = false;
  proceedToSubmitTin: boolean = false;
  firsRecord;
  isBusinessName: boolean = false;
  constructor(
    @Inject(DOCUMENT) private document,
    private http: HttpClient,
    private modalService: SuiModalService,
    private fb: FormBuilder,
    private documentSvc: DocumentService,
    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService,
    public modal: SuiModal<IEditCompanyDetailModalContext, void, void>,
    private AolService: AolService,
    private pdfViewerService: PdfViewerService,
    private errorHandler: ErrorHandlerService
  ) {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.companyTypes = this.organization?.jpaContractor?.companyType?.optionId;
    this.getCompanyType();
    this.toEdit = modal.context.data;
    if (modal.context.title == 'OTHER_TIN') {
      modal.context.title = 'Change of Other TIN';
    }
    console.log(this.toEdit);
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10000 });

    this.setForm();
    if (
      modal.context.data === 'ADDRESS' ||
      modal.context.data === 'TIN' ||
      modal.context.data === 'OTHER_TIN'
    ) {
      this.getDocumentUploaded();
    }
  }
  getCompanyType() {
    // let companyType = this.organization?.jpaContractor?.companyType?.optionId;
    if (
      this.companyTypes === 'business_name_actual' ||
      this.companyTypes === 'business_name'
    ) {
      this.isBusinessName = true;
    }
  }
  allLinkedDocuments: any = [];
  getTitle(title) {
    if (title === 'COMPANY_NAME') {
      return 'Change of Name';
    }
    if (title === 'RC_NUMBER') {
      return 'Change of Registration Details';
    }
    if (title === 'TIN') {
      return 'Change of TIN';
    }
    if (title === 'ADDRESS') {
      return 'Change of Address';
    }
    if (title === 'OTHER_TIN') {
      return 'Change of Other TIN';
    }
    if (title === 'CONTACT_INFORMATION') {
      return 'Change of Contact Information';
    }
  }
  LinkDocument(data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Select and link existing documents from ${data} Document Type`,
          '',
          data,
          this.uploads,
          ModalSize.Mini
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        documents.map((item) => this.allLinkedDocuments.push(item));
      })
      .onDeny(() => {});
  }

  returnDocumentType(data, id) {
    const filtered = data.filter((item) => {
      return item.documentTypeId.documentTypeName === id;
    });
    return filtered;
  }

  uploads: any = [];
  getDocumentUploaded() {
    this.pending = true;
    this.AolService.getDocumentUpload({
      optionId:
        this.toEdit === 'ADDRESS'
          ? 'change_of_address_document'
          : this.toEdit === 'TIN'
          ? 'change_of_tin_document'
          : 'other_tin',
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.uploads = res.filter((item) => item.isActive);
        console.log(this.uploads, 'this.uploads');
        this.documentss = this.uploads.map((doc) => ({
          ...doc,
          uploadedFiles: [],
        }));
        console.log(this.documentss, 'document');
      },
      (error) => {
        this.pending = false;
        this.error = this.errorHandler.formatError(error);
      }
    );
  }
  confirmTin() {
    this.pending = true;
    this.AolService.getTinFromFirs({
      organizationId: this.organizationForm.value.tinNumber,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        if (res.TaxPayerName) {
          this.firsRecord = res;
          this.confirmedTin = true;
          this.confirmDocumentSelected();
        } else {
          this.confirmedTin = false;
          this.proceedToSubmitTin = true;
          this.error =
            "Oops! It seems we're unable to retrieve your record from FIRS at the moment. Please ensure that the tin number provided is correct.  kindly provide your tax document or try again later.";
        }
      },
      (error) => {
        this.pending = false;
        this.confirmedTin = false;
        this.proceedToSubmitTin = true;
        this.error =
          "Oops! It seems we're unable to retrieve your record from FIRS at the moment. Please ensure that the tin number provided is correct.  kindly provide your tax document or try again later.";
      }
    );
  }

  ngOnInit(): void {}
  viewDocument(data: any) {
    this.pdfViewerService.viewPdf(data);
  }
  setForm() {
    let contractor = this.organization.jpaContractor;
    switch (this.toEdit) {
      case 'COMPANY_NAME':
        this.organizationForm = this.fb.group({
          companyName: ['', Validators.required],
        });
        this.organizationForm.patchValue(contractor);
        break;

      case 'RC_NUMBER':
        this.getOptionTypes();
        this.organizationForm = this.fb.group({
          rcNumber: ['', Validators.required],
          companyType: ['', Validators.required],
          ownershipType: ['', Validators.required],
          dateOfRegistration: ['', Validators.required],
        });
        this.organizationForm.patchValue(contractor);
        this.organizationForm.patchValue({
          companyType: contractor.actualCompanyType
            ? contractor.actualCompanyType?.optionId
            : contractor.companyType?.optionId,
        });

        this.organizationForm.patchValue({
          ownershipType: contractor.ownershipType.optionId,
        });
        this.organizationForm.patchValue({
          dateOfRegistration: new Date(contractor.dateOfRegistration),
        });
        break;

      case 'TIN':
        this.organizationForm = this.fb.group({
          tinNumber: ['', Validators.required],
          documents: [''],
        });
        this.organizationForm.patchValue(contractor);
        break;

      case 'OTHER_TIN':
        this.organizationForm = this.fb.group({
          tinNumber: ['', Validators.required],
          documents: [''],
        });
        this.organizationForm.patchValue(contractor);
        break;

      case 'ADDRESS':
        this.organizationForm = this.fb.group({
          headOfficeAddressStreet: ['', Validators.required],
          headOfficeAddressCity: ['', Validators.required],
          headOfficeAddressStateId: ['', Validators.required],
          headOfficeAddressZip: [''],
          countryOfRegistration: ['', Validators.required],
          documents: [''],
        });
        this.getCountry();
        this.getStates();
        this.organizationForm.patchValue(contractor);

        this.organizationForm.patchValue({
          headOfficeAddressStateId:
            contractor['headOfficeAddressState']['stateId'],
          countryOfRegistration:
            contractor['countryOfRegistration']['countryCode'],
        });
        break;

      case 'CONTACT_INFORMATION':
        this.organizationForm = this.fb.group({
          companyContactEmail: ['', Validators.required],
          companyContactAlternativeEmail: ['', Validators.required],
          companyContactPhone1: ['', Validators.required],
          website: [''],
        });
        this.organizationForm.patchValue(contractor);
        console.log('patched');
        break;

      default:
        break;
    }

    this.currentForm = this.organizationForm.value;
    if (this.organizationForm.get('companyContactEmail')) {
      this.companyEmailError = true;
      this.organizationForm
        .get('companyContactEmail')
        .valueChanges.pipe(
          tap((value) => {
            if (
              value &&
              value !== '' &&
              value !== this.organization.companyContactEmail
            ) {
              this.companyEmailLoading = true;
              this.companyEmailError = true;
              this.companyEmailServerError = false;
            }
          }),
          delay(800),
          debounceTime(800),
          distinctUntilChanged()
        )
        .subscribe((value) => {
          console.log('changed');
          if (
            value &&
            value !== '' &&
            value !== this.organization.companyContactEmail
          ) {
            this.http
              .get(
                `${environment.API_SERVER}/auth/company-email-availablity/${value}/`
              )
              .subscribe(
                (res) => {
                  this.companyEmailLoading = false;
                  this.companyEmailError = res['status'];
                },
                (error) => {
                  this.companyEmailLoading = false;
                  if (error['status'] !== 404) {
                    this.companyEmailServerError = false;
                  } else {
                    this.companyEmailServerError = true;
                  }
                }
              );
          }
        });
    } else {
      this.companyEmailError = false;
    }
  }

  submit() {}

  isFieldValid(field: string) {
    return (
      (!this.organizationForm.get(field).valid &&
        this.organizationForm.get(field).touched) ||
      (this.organizationForm.get(field).untouched && this.formSubmitAttempt)
    );
    return (
      (!this.documentForm.get(field).valid &&
        this.documentForm.get(field).touched) ||
      (this.documentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  submitDoc() {
    this.formSubmitAttempt = false;
    if (this.uploadedDocuments.length > 0) {
      let data: any = this.uploadedDocuments;
      let allDocuments = [];
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const formData: FormData = new FormData();
          const file = document;
          formData.append('file', file);
          let payload: any = { formValue: data, formData: formData };
          allDocuments.push(payload);
        }
      }
      allDocuments.map((item) => this.processUploadFile(item));
    } else {
      this.formSubmitAttempt = true;
    }
  }
  processUploadFile(data) {
    let uploadFormData = data['formData'];
    const values = data['formValue'];
    const jsonse = JSON.stringify(values);
    const blob = new Blob([jsonse], { type: 'application/json' });
    uploadFormData.append('data', blob);
    this.onUploadFile(uploadFormData);
  }
  onUploadFile(data) {
    this.nullify();
    this.pending = true;
    this.documentSvc
      .uploadSupportingDocument({
        changeRequestId: this.changeRequestId,
        body: data,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          if (this.toEdit === 'RC_NUMBER') {
            this.success =
              'Company registration details updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'COMPANY_NAME') {
            this.success =
              'Company name updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'TIN') {
            this.success =
              'Company TIN updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'OTHER_TIN') {
            this.success =
              'Company Other TIN updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'ADDRESS') {
            this.success =
              'Company address updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'CONTACT_INFORMATION') {
            this.success =
              'Company contact information updated successfully. You will be notified when your request has been verified';
          }
          setTimeout(() => {
            // this.getPage(1);
            this.modal.approve(null);
          }, 4000);
        },
        (error) => {
          this.pending = false;
          this.error = this.errorHandler.formatError(error);
        }
      );
  }

  confirmDocumentSelected() {
    if (
      this.toEdit === 'ADDRESS' ||
      (this.toEdit === 'TIN' && !this.confirmedTin) ||
      this.toEdit === 'OTHER_TIN'
    ) {
      let data: any = this.uploadedDocuments;
      if (data && data.length > 0) {
        for (const documentType of data) {
          for (const document of documentType.uploadedFiles) {
            const size = document.size;
            if (size > 10 * 1024 * 1024) {
              this.error = `File (${document.name}) size is too large, Maximum file size is 10MB`;
              return;
            }
          }
        }
      }
      if (this.uploadedDocuments.length > 0) {
        this.checkDoc();
      } else if (this.allLinkedDocuments.length > 0) {
        this.save();
      } else {
        // this.input.nativeElement.focus();
        // this.h3.nativeElement.focus();
        // this.error = 'Please upload the required Document';
        this.save();
      }
    } else if (this.toEdit === 'CONTACT_INFORMATION') {
      this.saveContact();
    } else {
      this.save();
    }
  }
  saveContact() {
    this.pending = false;
    console.log(this.organization);
    if (this.organizationForm.valid) {
      this.error = null;
      this.pending = true;
      this.success = null;
      let body = {
        email: this.organizationForm.value.companyContactEmail,
        alternativeEmail:
          this.organizationForm.value.companyContactAlternativeEmail,
        phone: this.organizationForm.value.companyContactPhone1,
        website: this.organizationForm.value.website,
      };
      if (this.modal.context.data) {
        this.organizationSvc
          .updateCEODetails({
            nccId: this.organization.jpaContractor.nccId,
            body: body,
          })
          .subscribe({
            next: () => {
              this.pending = false;
              this.success = 'Contact Information Updated';
              setTimeout(() => this.modal.approve(), 500);
              this.organizationForm.reset();
              window.location.reload();
            },
            error: (error: any) => {
              this.error = error?.error?.message
                ? error?.error?.message
                : error;
              this.pending = false;
            },
          });
      }
    }
  }
  allDocuments: any = [];
  checkDoc() {
    this.formSubmitAttempt = false;
    if (this.uploadedDocuments.length > 0) {
      let data: any = this.uploadedDocuments;
      console.log(data, 'data');
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const formData: FormData = new FormData();
          const file = document;
          formData.append('file', file);
          let formValue = {
            documentDescription: 'supporting document',
            documentName: documentType.documentTypeName,
            documentTypeId: documentType.documentTypeId,
          };
          let payload: any = { formValue: formValue, formData: formData };
          this.allDocuments.push(payload);
        }
      }
      console.log(this.allDocuments, 'new');
      this.allDocuments.map((item, index) => {
        this.processUpload(item, index);
      });
    } else {
      this.formSubmitAttempt = true;
    }
  }
  processUpload(data, i) {
    let uploadFormData = data['formData'];
    const values = data['formValue'];
    const jsonse = JSON.stringify(values);
    const blob = new Blob([jsonse], { type: 'application/json' });
    uploadFormData.append('data', blob);
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({
        organizationId: this.organizationId,
        body: uploadFormData,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.documentUploaded.push(res);
          if (i + 1 === this.allDocuments.length) {
            console.log(this.documentUploaded, 'this.documentUploaded');
            this.save();
            // console.log(index, this.allDocuments.length, 'before');
          }
        },
        (error) => {
          this.pending = false;
          this.error =
            'Error while uploading Utility Bills (Water Board, PHCN)';
        }
      );
  }

  onUploadFileSupporting(data) {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({ organizationId: this.organizationId, body: data })
      .subscribe(
        (res: any) => {
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error =
            'Error while uploading Utility Bills (Water Board, PHCN)';
        }
      );
    return 'hello';
  }
  // update form
  save() {
    this.pending = true;
    this.nullify();
    if (
      this.toEdit === 'ADDRESS' ||
      (this.toEdit === 'TIN' && !this.confirmedTin) ||
      this.toEdit === 'OTHER_TIN'
    ) {
      let emptyArray = [];
      this.allLinkedDocuments.map((item) => emptyArray.push(item));
      this.documentUploaded.map((item) => emptyArray.push(item));
      let requiredDocument = this.uploads.filter((item) => {
        return item['isRequired'];
      });
      const documentTypeIdSet = new Set(
        emptyArray.map((item) => item.documentTypeId?.documentTypeId)
      );
      console.log(documentTypeIdSet, requiredDocument, 'idSet');
      const objectsNotInSecondArray = requiredDocument.filter(
        (item) => !documentTypeIdSet.has(item.documentTypeId)
      );
      console.log(objectsNotInSecondArray, 'object');
      if (objectsNotInSecondArray.length > 0) {
        this.pending = false;
        this.error = 'Please upload the required Document';
        return;
      } else {
        this.organizationForm.value.documents = emptyArray;
      }
    }
    console.log(
      this.organizationForm.value,
      'this.organizationForm.value.documents'
    );
    if (this.toEdit === 'TIN' && this.firsRecord) {
      delete this.organizationForm.value.documents;
      this.organizationForm.value.firsRecord = this.firsRecord;
    }
    if (this.toEdit === 'TIN' && !this.confirmedTin) {
      this.organizationForm.value.document =
        this.organizationForm.value.documents[0];
      delete this.organizationForm.value.documents;
    }
    if (this.toEdit === 'OTHER_TIN' && this.firsRecord) {
      delete this.organizationForm.value.documents;
      this.organizationForm.value.firsRecord = this.firsRecord;
    }
    if (this.toEdit === 'OTHER_TIN' && !this.confirmedTin) {
      this.organizationForm.value.document =
        this.organizationForm.value.documents[0];
      delete this.organizationForm.value.documents;
    }
    let payload = {
      organization: {
        organizationId: this.organization.organizationId,
      },
      changeRequestType: this.toEdit,
      actionType: 'UPDATE',
      fromValue: JSON.stringify(this.currentForm),
      toValue: JSON.stringify(this.organizationForm.value),
    };
    this.organizationSvc
      .addChangeRequest({
        organizationId: this.organization.organizationId,
        body: payload,
      })
      .subscribe(
        (res) => {
          this.authSvc.setRefreshStorage('');
          // this.ngOnInit();
          this.changeRequestId = res['changeRequestId'];
          if (this.toEdit === 'RC_NUMBER') {
            this.success =
              'Company registration details updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'COMPANY_NAME') {
            this.success =
              'Company name updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'TIN') {
            this.success =
              'Company FIRS TIN updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'OTHER_TIN') {
            this.success =
              'Company Other TIN updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'ADDRESS') {
            this.success =
              'Company address updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'CONTACT_INFORMATION') {
            this.success =
              'Company contact information updated successfully. You will be notified when your request has been verified';
          } else if (this.toEdit === 'ADDRESS') {
            this.success =
              'Company address updated successfully. You will be notified when your request has been verified';
          }
          setTimeout(() => {
            this.pending = false;
            this.modal.approve();
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = this.errorHandler.formatError(error);
        }
      );
    // return '';
  }

  getOptionTypes() {
    this.organizationSvc
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((res: any) => res['rows']),
        map((res: any) => {
          const options = {
            ownershipType: [],
            companyType: [],
            errorOption: [],
            providerType: [],
          };
          res.forEach((option) => {
            // console.log(option)
            switch (option.optionType.optionTypeId) {
              case 'ownership_type':
                options.ownershipType.push(option);
                break;
              case 'actual_company_type':
                options.companyType.push(option);
                break;
              case 'foreign_company_providers':
                options.providerType.push(option);
                break;
              default:
                options.errorOption.push(option);
            }
          });
          return options;
        })
      )
      .subscribe(
        (res) => {
          console.log(res.companyType);

          this.companyType = res.companyType;
          this.ownershipType = res.ownershipType;
          this.companyTypeData = res.companyType;
          this.ownershipTypeData = res.ownershipType.slice(0, 2);
          console.log(this.ownershipTypeData, 'ownershipType');
        },
        (error) => {
          this.error = error.error || error;
        }
      );
  }

  getCountry() {
    this.organizationSvc
      .getCountries({ organizationId: this.organization.organizationId })
      .subscribe((res) => {
        this.countries = res['rows'];
      });
  }

  getStates() {
    this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
      this.states = res['rows'];
    });
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
}

export class EditCompanyDetailModal extends ComponentModalConfig<
  IEditCompanyDetailModalContext,
  void,
  void
> {
  constructor(title: string, data?: any, size: ModalSize = ModalSize.Mini) {
    super(EditCompanyDetailModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
